import {isString} from 'lodash-es';
import {HttpErrorResponse} from '@angular/common/http';

export class DcpErrorHandlingUtil {
  private static readonly ERROR_TYPE_BACKEND = 'BACKEND';
  private static readonly ERROR_TYPE_FRONTEND = 'FRONTEND';
  private static readonly SEVERITY_UNKNOWN = 'UNKNOWN';

  public static mapValidationToInternalError(validation: any) {
    return {
      errorType: this.ERROR_TYPE_BACKEND,
      name: validation[0].code,
      message: validation[0].description,
      severity: validation[0].severity,
    };
  }

  public static mapPricingToInternalError(priceSummary: any) {
    return {
      errorType: this.ERROR_TYPE_BACKEND,
      name: priceSummary.pricingErrorCode,
      message: priceSummary.pricingErrorMessage,
      severity: this.SEVERITY_UNKNOWN,
    };
  }

  public static mapToInternalInfo(info: any) {
    return {
      message: info?.message,
      body: info?.body,
      status: 200,
    };
  }

  public static mapToInternalError(error: any) {
    if (!error) {
      return {
        errorType: this.ERROR_TYPE_FRONTEND,
        name: 'UNKNOWN',
        message: 'UNKNOWN',
        severity: this.SEVERITY_UNKNOWN,
      };
    } else if (Object.keys(error).length === 0) {
      return {
        errorType: this.ERROR_TYPE_FRONTEND,
        name: error.name,
        message: error.message,
        stack: error.stack,
        severity: this.SEVERITY_UNKNOWN,
      };
    } else if (isString(error)) {
      return {
        errorType: this.ERROR_TYPE_FRONTEND,
        name: 'UNKNOWN',
        message: error,
        severity: this.SEVERITY_UNKNOWN,
      };
    }

    if (this.isBackendError(error)) {
      if (error?.error?.validation?.length > 0) {
        return {
          ...error,
          errorType: this.ERROR_TYPE_BACKEND,
          name: error?.error?.validation[0].code,
          message: error?.error?.validation[0].description,
          severity: error?.error?.validation[0].severity,
        };
      } else if (error?.error?.errors?.length > 0) {
        const dependencyError = error?.error?.errors[0];
        return {
          ...error,
          errorType: this.ERROR_TYPE_BACKEND,
          name: dependencyError?.errorCode ?? error.name + '_' + error?.status + ':' + dependencyError.type,
          message: error.message + ' (' + dependencyError.message + ')',
          severity: 'ERROR',
        };
      } else if (error.errorCode) {
        return {
          ...error,
          errorType: this.ERROR_TYPE_BACKEND,
          name: error.errorCode,
          message: error.description,
          severity: this.SEVERITY_UNKNOWN,
        };
      } else {
        return {
          ...error,
          errorType: this.ERROR_TYPE_BACKEND,
          name: error.name + '_' + error?.status,
          message: error?.statusText + ' (' + error.url + ')',
          severity: this.SEVERITY_UNKNOWN,
        };
      }
    }

    if (!error.errorCode) {
      return {
        ...error,
        errorType: this.ERROR_TYPE_FRONTEND,
        name: error.name || 'UNKNOWN',
        message: error.message,
        stack: error.stack,
        severity: this.SEVERITY_UNKNOWN,
      };
    }
  }

  private static isBackendError(error: any) {
    return error instanceof HttpErrorResponse || error?.name === 'HttpErrorResponse' || error.errorCode;
  }
}
